module.exports = __webpack_public_path__ + "img/windy.2318ec9e.jpeg";